/**
 * Assets whose picture lives under another asset's name.
 *
 * The pipeline lets one asset reuse another's rendered icon, and it records that in the manifest. The
 * icon URL, though, is built synchronously from the asset id while the page renders, so it never saw
 * the manifest's answer: the alliance coin asked for /assets/icons/alliance_coin.png, which has never
 * existed, and the item detail showed a broken image. Four decorations were in the same state.
 *
 * Catalogue fallbacks generated from public/assets/manifest.json; separately sealed authored item art
 * takes precedence in iconUrl. icon-overrides.test.ts regenerates this table and fails if the
 * pipeline adds a reuse that is not listed here.
 */
export const ICON_OVERRIDES: Readonly<Record<string, { "1x": string; "2x": string }>> = {
  "itm.alliance_coin": { "2x": "/assets/icons/token_prestige.png", "1x": "/assets/icons/token_prestige@1x.png" },
  // The Dominion teleporter (D103) shares the advanced teleport's picture until the art pass draws its own (D110).
  "itm.alliance_teleport": { "2x": "/assets/icons/teleport_advanced.png", "1x": "/assets/icons/teleport_advanced@1x.png" },
  // Legacy pipeline aliases; authored tickets and keys now take precedence in iconUrl.
  "itm.wild_ticket": { "2x": "/assets/icons/token_event.png", "1x": "/assets/icons/token_event@1x.png" },
  "itm.gacha_key": { "2x": "/assets/icons/token_salvage.png", "1x": "/assets/icons/token_salvage@1x.png" },
  // Legacy pipeline aliases; the badge, order and transport drone have dedicated authored replacements.
  "itm.research_badge": { "2x": "/assets/icons/ui.medal.gold.png", "1x": "/assets/icons/ui.medal.gold@1x.png" },
  "itm.merit_order": { "2x": "/assets/icons/ui.frame.gold.png", "1x": "/assets/icons/ui.frame.gold@1x.png" },
  "itm.proto_blueprint": { "2x": "/assets/icons/blueprint.png", "1x": "/assets/icons/blueprint@1x.png" },
  "itm.node_drone": { "2x": "/assets/icons/drone_core.png", "1x": "/assets/icons/drone_core@1x.png" },
  "itm.deco_garden": { "2x": "/assets/icons/deco_garden_dome.png", "1x": "/assets/icons/deco_garden_dome@1x.png" },
  "itm.deco_yard_service": { "2x": "/assets/icons/yard_service.png", "1x": "/assets/icons/yard_service@1x.png" },
  "itm.deco_yard_supply": { "2x": "/assets/icons/yard_supply.png", "1x": "/assets/icons/yard_supply@1x.png" },
  "itm.deco_yard_water": { "2x": "/assets/icons/yard_water.png", "1x": "/assets/icons/yard_water@1x.png" },
};
